import { Component } from '@angular/core';

@Component({
  selector: 'app-user-admin',
  templateUrl: './user-admin.component.html',
  standalone: false,
})
export class UserAdminComponent {}
